import { NavigationGuard, Route } from "vue-router";
import { Dictionary } from "vue-router/types/router";
import { TelemetryService } from "@/services";

const telemetryEnterGuard: NavigationGuard = (to, from, next) => {
    TelemetryService.startTrackPageView(to.name);
    next();
};

const telemetryLeaveGuard = (to: Route) => {
    const paramsProps = mapProperties(to.params);
    const queryProps = mapProperties(to.query);

    const properties = { ...paramsProps, ...queryProps };

    TelemetryService.stopTrackPageView(to.name, to.fullPath, properties);
};

function mapProperties(values: Dictionary<string | string[]>): { [name: string]: string } {
    const props = {};
    for (const key of Object.keys(values)) {
        props[key] = values[key];
    }

    return props;
}

export { telemetryEnterGuard, telemetryLeaveGuard };
